export default "__VITE_ASSET__CNyY3p2E__"